var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76256 4.01256C3.09075 3.68437 3.53587 3.5 4 3.5H8.375C8.65114 3.5 8.875 3.72386 8.875 4C8.875 4.27614 8.65114 4.5 8.375 4.5H4C3.80109 4.5 3.61032 4.57902 3.46967 4.71967C3.32902 4.86032 3.25 5.05109 3.25 5.25V14C3.25 14.1989 3.32902 14.3897 3.46967 14.5303C3.61032 14.671 3.80109 14.75 4 14.75H12.75C12.9489 14.75 13.1397 14.671 13.2803 14.5303C13.421 14.3897 13.5 14.1989 13.5 14V9.625C13.5 9.34886 13.7239 9.125 14 9.125C14.2761 9.125 14.5 9.34886 14.5 9.625V14C14.5 14.4641 14.3156 14.9092 13.9874 15.2374C13.6592 15.5656 13.2141 15.75 12.75 15.75H4C3.53587 15.75 3.09075 15.5656 2.76256 15.2374C2.43437 14.9092 2.25 14.4641 2.25 14V5.25C2.25 4.78587 2.43437 4.34075 2.76256 4.01256Z",
    fill: "#1E7DFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3642 3.48408L7.90697 9.26426L7.52117 10.8074L9.04935 10.4254L14.5014 4.65063C14.5047 4.64715 14.5081 4.64371 14.5115 4.64033C14.6642 4.48759 14.75 4.28044 14.75 4.06443C14.75 3.84843 14.6642 3.64128 14.5115 3.48854C14.3587 3.33581 14.1516 3.25 13.9356 3.25C13.7217 3.25 13.5165 3.33414 13.3642 3.48408ZM12.6526 2.78144C12.9928 2.44116 13.4543 2.25 13.9356 2.25C14.4168 2.25 14.8783 2.44116 15.2186 2.78144C15.5588 3.12171 15.75 3.58322 15.75 4.06443C15.75 4.54306 15.5609 5.00219 15.224 5.34193L9.67607 11.2183C9.61051 11.2877 9.52643 11.3369 9.43378 11.3601L6.95526 11.9797C6.78487 12.0223 6.60462 11.9724 6.48043 11.8482C6.35624 11.724 6.30632 11.5438 6.34892 11.3734L6.96855 8.89484C6.98934 8.81165 7.03119 8.73521 7.09005 8.67286L12.6426 2.79174C12.6458 2.78826 12.6492 2.78482 12.6526 2.78144Z",
    fill: "#1E7DFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.6b0899bfddc18c59f9c262df599fcc70.svg";
export { ForwardRef as ReactComponent };